/**
 * Platform Configuration - Single source of truth for admin emails and platform constants.
 * Instead of hardcoding these across 30+ files, import from here.
 * 
 * To update: Change values here OR use the Company Settings API (Super Admin → Company Settings tab)
 */

// Super admin emails - centralized from scattered hardcoded values
export const SUPER_ADMIN_EMAILS = [
  'me@iamnaomithomas.com',
];

// Check if a user is a super admin - primarily by role, email as fallback for bootstrap
export const isSuperAdmin = (user) => {
  if (!user) return false;
  if (user.role === 'super_admin' || user.role === 'admin' || user.is_super_admin) return true;
  if (user.email && SUPER_ADMIN_EMAILS.includes(user.email.toLowerCase())) return true;
  return false;
};

// Legacy - check by email only (for backwards compatibility)
export const isSuperAdminEmail = (email) => {
  if (!email) return false;
  return SUPER_ADMIN_EMAILS.includes(email.toLowerCase());
};

// Platform defaults (overridden by Company Settings API when available)
export const PLATFORM_DEFAULTS = {
  company_name: 'Phygital',
  tagline: 'Where Physical Meets Digital',
  support_email: 'me@iamnaomithomas.com',
  website: 'https://phygital.systems',
};
